// extracted by mini-css-extract-plugin
export default {"footer":"AppFooter_footer__HRN8W","copyright-container":"AppFooter_copyright-container__f2vK1"};